export const UPDATE = "notifications/UPDATE";
export const APPEND = "notifications/APPEND";
export const UPDATE_ONE = "notifications/UPDATE_ONE";
export const DESTROY = "notifications/DESTROY";
export const LOADING = "notifications/LOADING";
